"use client";
import * as React from "react";
const SvgSentimentDissatisfiedFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m5.2-.8a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4M12 6a1.2 1.2 0 1 1-2.4 0A1.2 1.2 0 0 1 12 6m-2.42 6.02A3 3 0 0 0 8 11.6a3 3 0 0 0-1.58.42L6 11.55s0-.02-.4-.45a4.4 4.4 0 0 1 2.4-.7q1.35.02 2.38.71z", clipRule: "evenodd" }));
export {
  SvgSentimentDissatisfiedFilled as default
};
